const ButtonShowMore = ({ text, onClick }) => (
    <button className="button show-more full-width has-children" onClick={onClick}>
        {text}
    </button>
);

export default ButtonShowMore;
